import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from '../Texture.module.sass';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';

function TextureBlock(props) {
  const {
    setTexture, selectedTexture, texture, image, editable, color, className,
  } = props;

  const inputRef = useRef(null);

  useEffect(() => {
    window.lazyLoad.update();
  });

  const onClick = () => {
    setTexture(texture);

    if (!editable) { return; }

    inputRef.current.focus();
  };

  const onInputChange = (event) => {
    setTexture(event.target.value);
  };

  const style = {};
  if (selectedTexture === texture) {
    style.background = color;
  }

  return (
    <ClickableDiv
      className={`${styles.block} ${className}`}
      onClick={onClick}
      style={style}
    >
      <div className={styles.image}>
        <img className="lazyload blur" data-src={image} src={image.placeholder} alt={texture} />
      </div>
      { !editable && (
        <div className={styles.name}>
          {texture}
        </div>
      )}
      { editable && (
        <input type="text" ref={inputRef} placeholder="Other" value={texture} onChange={onInputChange} />
      )}
    </ClickableDiv>
  );
}

TextureBlock.propTypes = {
  setTexture: PropTypes.func.isRequired,
  selectedTexture: PropTypes.string,
  texture: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  editable: PropTypes.bool,
  color: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default TextureBlock;
